import { render } from "./Address.vue?vue&type=template&id=6c6bd8c1&scoped=true&ts=true"
import script from "./Address.vue?vue&type=script&lang=ts"
export * from "./Address.vue?vue&type=script&lang=ts"

import "./Address.vue?vue&type=style&index=0&id=6c6bd8c1&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6bd8c1"]])

export default __exports__